import React from 'react';
import { Img } from 'react-image';
import classnames from 'classnames';
import styles from './Image.scss';

export default function Image({ src, size, className, children }) {
  return (
    <span className={classnames('icon', styles.icon, styles[size], className)}>
      <Img
        src={src}
        className={classnames(styles.mainImage)}
        loader={<>{children}</>}
        unloader={<>{children}</>}
      />
    </span>
  );
}
